import React from 'react';

const LoadMoreButton = ({ onClick, isLoading, text = "Load More" }) => (
  <button
    className="w-full bg-primary-700 hover:bg-primary-800 text-sm text-white rounded-md p-2 my-3 transition-colors disabled:opacity-50 font-roboto-flex"
    onClick={onClick}
    disabled={isLoading}
  >
    {isLoading ? "Loading..." : text}
  </button>
);

export default LoadMoreButton;
